import { call, put } from 'redux-saga/effects';
import * as api from '../../api';
import { hideModal, setCurrentId, showToast } from '../actions';
import {
  createWarehouse,
  deleteWarehouse,
  getWarehouses,
  updateWarehouse,
} from '../actions/warehouses';

export function* getWarehousesSaga(action) {
  try {
    const response = yield call(api.getWarehouses, action.payload);
    yield put(getWarehouses.getWarehousesSuccess(response?.data.warehouses));
  } catch (error) {
    console.log(error);
    yield put(
      showToast({
        message: error.response?.data.message
          ? error.response?.data.message
          : 'Lỗi máy chủ',
        type: error.response?.data.success ? 'error' : 'error',
      })
    );
    yield put(getWarehouses.getWarehousesFailure(error.response?.data));
  }
}

export function* createWarehouseSaga(action) {
  try {
    const response = yield call(api.createWarehouse, action.payload);
    yield put(createWarehouse.createWarehouseSuccess(response?.data.warehouse));
    yield put(hideModal());
    yield put(setCurrentId(0));
    yield put(
      showToast({
        message: response?.data.message
          ? response?.data.message
          : 'Lỗi máy chủ',
        type: response?.data.success ? 'success' : 'error',
      })
    );
  } catch (error) {
    console.log(error);
    yield put(
      showToast({
        message: error.response?.data.message
          ? error.response?.data.message
          : 'Lỗi máy chủ',
        type: error.response?.data.success ? 'error' : 'error',
      })
    );
    yield put(createWarehouse.createWarehouseFailure(error.response?.data));
  }
}

export function* updateWarehouseSaga(action) {
  try {
    const response = yield call(api.updateWarehouse, action.payload);
    yield put(updateWarehouse.updateWarehouseSuccess(response?.data.warehouse));
    yield put(hideModal());
    yield put(setCurrentId(0));
    yield put(
      showToast({
        message: response?.data.message
          ? response?.data.message
          : 'Lỗi máy chủ',
        type: response?.data.success ? 'success' : 'error',
      })
    );
  } catch (error) {
    console.log(error);
    yield put(
      showToast({
        message: error.response?.data.message
          ? error.response?.data.message
          : 'Lỗi máy chủ',
        type: error.response?.data.success ? 'error' : 'error',
      })
    );
    yield put(updateWarehouse.updateWarehouseFailure(error.response?.data));
  }
}

export function* deleteWarehouseSaga(action) {
  try {
    const response = yield call(api.deleteWarehouse, action.payload);
    yield put(deleteWarehouse.deleteWarehouseSuccess(response?.data.warehouse));
    yield put(hideModal());
    yield put(setCurrentId(0));
    yield put(
      showToast({
        message: response?.data.message
          ? response?.data.message
          : 'Lỗi máy chủ',
        type: response?.data.success ? 'success' : 'error',
      })
    );
  } catch (error) {
    console.log(error);
    yield put(
      showToast({
        message: error.response?.data.message
          ? error.response?.data.message
          : 'Lỗi máy chủ',
        type: error.response?.data.success ? 'error' : 'error',
      })
    );
    yield put(deleteWarehouse.deleteWarehouseFailure(error.response?.data));
  }
}
